function onReady() {
	if (!App.jivo.id) {
		return;
	}

	setTimeout(() => {
		let css = document.querySelector('.jv-css');
		if (css) css.remove();

		let script = document.createElement('script');

		script.setAttribute('src',`//code-eu1.jivosite.com/widget/${App.jivo.id}`);
		script.setAttribute('id', 'jivo');
		script.onload = () => {
			window.jivo_init();
		};
		document.body.appendChild(script);
	}, 100);
}

document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);
